import { type Component } from "solid-js";

/**
 * AplombScoreBadge — indicateur numérique 0-100 avec bande sémantique.
 * Contrainte ADR-0011 : un chiffre s'explique ou disparaît → prop `source` obligatoire.
 */
export interface AplombScoreBadgeProps {
  score: number; // 0..100
  source: string; // ex: "8 composantes bayésiennes (ADR-0007)"
  size?: "compact" | "regular" | "large";
}

type Band = "high" | "mid" | "low";

function bandFor(score: number): Band {
  if (score >= 75) return "high";
  if (score >= 50) return "mid";
  return "low";
}

export const AplombScoreBadge: Component<AplombScoreBadgeProps> = (props) => {
  const size = () => props.size ?? "regular";
  const band = () => bandFor(props.score);
  return (
    <div
      class={`a-score a-score--${size()} a-score--${band()}`}
      role="img"
      aria-label={`Score composite ${props.score} sur 100, source : ${props.source}`}
    >
      <span class="a-score__value">{props.score}</span>
      <span class="a-score__unit">/100</span>
      <span class="a-score__source">{props.source}</span>
    </div>
  );
};
